<script>
// @ts-nocheck

    import user from '$lib/stores/user'
    import Frame from '$lib/components/layout/Frame.svelte'
    import {
        capitalize,
        validarCuit,
        validarDni,
        validarLibreta,
        validateDoc,
    } from '$lib/utils'
    import { onMount } from 'svelte'
    import { Turnstile } from 'svelte-turnstile'
    import Redirect from '$lib/components/layout/Redirect.svelte'
    import { validateEmail } from '$lib/utils'
    import { useLocation, useNavigate } from 'svelte-navigator'
    import toast, { Toaster } from 'svelte-french-toast'
    import {
        InputPassword,
        Button,
        Link,
        CheckBox,
        Row,
        Alert,
        InputText,
        SelectX,
        Typography,
        Avatar,
        Select,
        BackDrop,
        Modal,
    } from '$lib/components/UI/'
    import { API_URL, CLOUDFLARE_SITEKEY, ENV } from '$lib/conf'
    let tipo_doc = 'dni',
        no_doc,
        password,
        email,
        username
    let isLoading = false
    let messageError = null
    let redirect = '/home'
    let rememberUser = false
    let rememberedUser = null
    let resetPassword = false
    let resetPasswordErrMsg = ''
    let waiting = false
    let isUserBloqued = false
    const location = useLocation()
    const navigate = useNavigate()
    const tdoc = [
        { label: 'DNI', value: 'dni', validation: validarDni },
        { label: 'CUIT', value: 'cuit', validation: validarCuit },
        { label: 'CUIL', value: 'cuil', validation: validarCuit },
        {
            label: 'Libreta de Enrolamiento',
            value: 'le',
            validation: validarLibreta,
        },
        { label: 'Libreta Cívica', value: 'lc', validation: validarLibreta },
    ]
    // let cfToken;
    // let skipCFVerification = !ENV.PROD;
    // const clearCFToken = () => {cfToken = undefined}
    // const setCFToken = (e) => {
    //     cfToken = e.detail.token
    // }
    onMount((_) => {
        console.log($location)
        if ($location.state) {
            // if ("msg" in $location.state) {
            //   messageError = $location.state.msg;
            // }
            // if ("redirect" in $location.state && $location.state.redirect) {
            //   redirect = $location.state.redirect;
            // }
            messageError = $location?.state?.msg || null
            redirect = $location?.state?.redirect || '/home'
            console.log(`Redirect; ${redirect} | Message Err: ${messageError}`)
        }
        let lastUser = window.localStorage.getItem('lastUser')
        if (lastUser) {
            lastUser = JSON.parse(lastUser)
            rememberedUser = lastUser
        }
        // if ($user !== null) navigate(redirect ? redirect : "/home");
        if ($user) navigate(redirect)
    })
    $: if (tipo_doc && no_doc) {
        username = `${tipo_doc}|${no_doc}`
    }
    $: if (rememberedUser !== null) {
        no_doc = rememberedUser?.document || ''
        tipo_doc = rememberedUser?.doc_type || ''
    }
    $: valid =
        username &&
        username.length > 2 &&
        password &&
        password.length > 2 &&
        tipo_doc
        // && (!ENV.PROD ? (skipCFVerification ? true : cfToken !== undefined) : cfToken !== undefined)
    $: console.log(`
    redirect: ${redirect}
  `)
    function sendSolicitud(userBloked = false) {
        waiting = true
        resetPasswordErrMsg = ''
        if (!userBloked) {
            fetch(
            `${API_URL}/services/resetPassword`,{
                method:'POST',
                body: JSON.stringify({doc_type: tipo_doc, doc_no: no_doc, email}),
                headers:{
                //  'Content-Type': 'application/json'    
                }
            }).then(async (res) => {
                waiting = false
                if (res.ok) {
                    let ret = await res.json()
                    navigate('/resetPassword',{ state: { challenge: ret.requestId, email } })
                } else {
                    resetPasswordErrMsg = 'No se encontró un usuario con estas credenciales.'//await res.text()
                }
            })
        } else {
            isUserBloqued = true
            waiting = false
            resetPassword = true
        }
    }
    async function login() {
        messageError = false
        isLoading = true
        await user.login(username, password, async (ok, data) => {
            isLoading = false
            if (ok) {
                let name =
                    data.name.split(' ')[0] + ' ' + data.lastName.split(' ')[0]
                let ret = {
                    name: capitalize(name),
                    role: 'Administrador', //tomar desde la api en el futuro
                    company: Object.values(data.accounts)[0].name,
                    doc_type: tipo_doc,
                    document: no_doc,
                }
                if (rememberUser) {
                    window.localStorage.setItem('lastUser', JSON.stringify(ret))
                }
            } else {
                messageError = data?.message
                console.log({messageError})
                if (messageError === 'Usuario Bloqueado') {
                    sendSolicitud(true)
                }
            }
            // await toPath();
        })
    }
</script>
<!-- <svelte:window on:keydown={event => {
    let comb = event.ctrlKey && event.altKey && event.code == 'KeyV'
    if(comb) {
        skipCFVerification = !skipCFVerification
        toast.success(`Verificacion Cloudflare ${!skipCFVerification ? "activa" : "inactiva"}.`)
    }
}}/> -->
<Toaster
    position="bottom-center"
    containerStyle="position:fixed; z-index: var(--lvl-5)"
/>
{#if !$user}
    <Frame background="grey" style="padding: 57px 0">
        <div>
            {#if rememberedUser}
                {@const name = capitalize(rememberedUser.name.split(' ')[0])}
                <Avatar size="default" name={rememberedUser.name} />
                <Typography style="margin: 0 0 4px 0" type="h2"
                    >¡Hola {name}!</Typography
                >
                <Typography
                    type="body"
                    style="margin: 0 0 4px 0"
                    color="grey-800"
                    >{rememberedUser.role} | {rememberedUser.company}</Typography
                >
            {:else}
                <Typography
                    style="margin: 0 0 4px 0; text-align: center; width: 100%"
                    type="h2">¡Te damos la bienvenida!</Typography
                >
                <Typography
                    style="margin: 0 0 4px 0"
                    type="subtitle"
                    color="grey-800">Por favor ingresá tus datos</Typography
                >
                <Row>
                    <Select
                        bind:value={tipo_doc}
                        label="Tipo de documento"
                        options={tdoc}
                        disabled={isLoading}
                    />
                    <InputText
                        label="Documento"
                        placeholder="Nro. de documento"
                        disabled={isLoading}
                        maxLength={11}
                        bind:value={no_doc}
                        validation={tdoc.find(({ value }) => value === tipo_doc)
                            ?.validation}
                    />
                </Row>
            {/if}
            <InputPassword
                label="Contraseña"
                placeholder="Ingresá tu contraseña"
                disabled={isLoading}
                on:keyup={({
                    detail: {
                        event: { key },
                    },
                }) => {
                    if (key === 'Enter') login()
                }}
                bind:value={password}
            />
            <Row align="center" justify="space-between">
                {#if rememberedUser === null}
                    <CheckBox bind:value={rememberUser} disabled={isLoading}
                        >Recordar Usuario</CheckBox
                    >
                {/if}
                <Link
                    style="align-self: center;opacity: {isLoading ? 0.5 : 1}"
                    disabled={isLoading}
                    on:click={(_) => (resetPassword = true)}
                >¿Olvidó su contraseña?</Link>
            </Row>
            {#if messageError}
                <Alert style="width: 100%" type="error">{messageError}</Alert>
            {/if}
            <!-- {#if !skipCFVerification}
                <Turnstile
                    siteKey={CLOUDFLARE_SITEKEY}
                    theme="light"
                    size="flexible"
                    on:expired={clearCFToken}
                    on:turnstile-expired={clearCFToken}
                    on:timeout={clearCFToken}
                    on:turnstile-timeout={clearCFToken}
                    on:callback={setCFToken}
                    on:turnstile-callback={setCFToken}
                    on:error={(r) => console.log('ERROR CFT', r)}
                    on:turnstile-error={(r) => console.log('ERROR CFT', r)}
                />
            {/if} -->
            <Button
                on:click={login}
                disabled={!valid || isLoading}
                style="width: 100%"
                label="Iniciar sesión"
            />
            {#if rememberedUser}
                <Button
                    style="width: 100%"
                    type="other"
                    label="Iniciar con otro usuario"
                    disabled={isLoading}
                    on:click={(_) => {
                        window.localStorage.removeItem('lastUser')
                        rememberedUser = null
                    }}
                />
            {/if}
            {#if rememberedUser === null}
                <span>
                    <Typography style="margin: 0" type="subtitle"
                        >¿Aún no tenes usuario?</Typography
                    >
                    <Typography
                        style="margin: 0"
                        color="grey-800"
                        type="caption"
                        >Solicítalo al <Link
                            href="mailto:mesadeayuda@lacaja.com.ar"
                            >mesadeayuda@lacaja.com.ar</Link
                        ></Typography
                    >
                </span>
            {/if}
        </div>
    </Frame>
    <BackDrop bind:visible={resetPassword}>
        <Modal
            title={isUserBloqued ? "Usuario Bloqueado" : "¿Olvidaste tu contraseña?"}
            closeable={!waiting}
            subtitle={isUserBloqued ? "Ingresá tus datos para desbloquear tu usuario." : "Ingresá tus datos para solicitar el cambio de contraseña."}
            scrolleable={false}
            on:close={(_) => {
                if (!waiting) {resetPassword = false; isUserBloqued = false}
            }}
            on:clickout={(_) => {
                if (!waiting) {resetPassword = false; isUserBloqued = false}
            }}
        >
            <Row>
                <Select
                    disabled={waiting}
                    label="Tipo de documento"
                    bind:value={tipo_doc}
                    options={tdoc}
                />
                <InputText
                    disabled={waiting}
                    label="Número de documento"
                    validation={tdoc.find(({ value }) => value === tipo_doc)?.validation}
                    bind:value={no_doc}
                />
            </Row>
            <Row>
                <InputText label="Email" disabled={waiting} bind:value={email} validation={validateEmail}/>
            </Row>
            {#if resetPasswordErrMsg}
                <Alert type="error" style="width: 100%"
                    >{resetPasswordErrMsg}</Alert
                >
            {/if}
            <svelte:fragment slot="buttonSet">
                <span
                    style="display: flex; ;width: 100%; flex-direction: row; justify-content: flex-end"
                >
                    <Button
                        on:click={(_) => sendSolicitud(false)}
                        disabled={waiting ||
                            !(
                                tipo_doc &&
                                tipo_doc.length >= 2 &&
                                no_doc &&
                                email && validateEmail(email) &&
                                no_doc.length >= 7
                            )}
                        label="Recuperar contraseña"
                    />
                </span>
            </svelte:fragment>
        </Modal>
    </BackDrop>
{:else}
    <Redirect path={redirect} />
{/if}

<!-- {/if} -->
<style>
    div {
        width: 596px;
        /* height: 100%; */
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        display: flex;
        margin: auto;
        align-items: center;
        padding: 48px 111px;
        gap: 10px;
        align-self: center;
        border: 1px solid #ebebeb;
        border-radius: 8px;
        background-color: var(--color-white);
    }
    div span {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding: 0;
        margin: 0;
    }
</style>